export default "__VITE_ASSET__CmYtbmQZ__"